<template>
    <div>
        <div class="banner">
            <Swipe ref="swiper" :auto="6000" :disabled="true">
                <SwipeItem v-for="img in bannerList" :key="img.Img" >
                    <img :src="('/'+img.Img)|replaceImgSrc('dfyb1')" style="width:100%;" class="swipe-imgs" @click="bannerToHotel(img)"/>
                </SwipeItem>
            </Swipe>
            <div class="back back-btn" @click="bannerBtn('prev')">
                <i class="iconfont icon-back"></i>
            </div>
            <div class="back more-btn" @click="bannerBtn('next')">
                <i class="iconfont icon-more"></i>
            </div>

        </div>
        <div class="search-bar">
            <!--<div class="rule">-->
            <div :class="isSeniorSearch?'m-search':'m-search senior-m-search'">
                <div :class="calendar.show||isRoomPeopelShow||isHotCityShow||isRoomCountShow||isHotelStarShow||isHotelPriceShow||isCountryShow?'layer-active m-search-box':'m-search-box'">
                    <div :class="isKeyResultShow&&!calendar.show?'m-search-main layer-active':'m-search-main'"
                         @click="searchScroll">
                        <div :class="isKeyResultShow?'main-left layer-active':'main-left'" ref="keyRef">
                            <i class="iconfont icon-search"></i>
                            <input type="text" data-type="searchAll" maxlength="50" placeholder="酒店名称/城市/景点/关键词"
                                   v-model="key" @click="close();searchBtn()" class="searchAll" ref="keyInput" @input="searchInput()"/>
                            <i class="iconfont icon-guanbi search-close-btn" @click="key=''" v-if="key"></i>
                        </div>

                        <div class="main-right">
                            <i class="iconfont icon-calendar"></i>
                            <div class="date-box">
                                <input type="text" class="date-time" data-type="time"
                                       @click="calendar.show = true;searchScroll()" v-model="CheckIn">
                                <span>{{CheckIn|delUTC|dateWeek}}</span>
                            </div>
                            <span class="day-count">{{getDays(CheckIn,CheckOut)}}晚</span>
                            <div class="date-box">
                                <input type="text" class="date-time" data-type="time"
                                       @click="close();calendar.show = true;searchScroll()" v-model="CheckOut">
                                <span>{{CheckOut|delUTC|dateWeek}}</span>
                            </div>
                            <transition name="fade" enter-active-class="animated bounceInUp"
                                        leave-active-class="animated fadeOutDown"
                                        :duration="300">
                                <DatePicker @select="calendar.select" v-show="calendar.show" :start="calendar.start"
                                            :beginDate="calendar.begin" :endDate="calendar.end"></DatePicker>
                            </transition>
                        </div>
                    </div>

                    <div :class="isKeyResultShow?'layer-active m-search-btn':'m-search-btn'" @click="routeToHotel" >搜索
                    </div>
                    <HotCity @select="hotCity" :productType="ProductType" :isHotCityShow="isHotCityShow"></HotCity>
                    <SearchAll :keyword="key" :productType="'4'" :isKeyResultShow="isKeyResultShow" @selectCity="selectCity"
                               @selectHotel="selectHotel" @selectLandmark="selectLandmark"></SearchAll>

                    <div :class="isSeniorSearch?'high-search':'high-search senior-high-search'"
                         :style="calendar.show||isRoomPeopelShow || isRoomCountShow||isHotelStarShow||isHotelPriceShow||isCountryShow?'z-index:-2':''"
                         @click="isSeniorSearch = !isSeniorSearch" >
                        <span>{{isSeniorSearch?'收起':'高级搜索'}}</span>
                        <i :class="isSeniorSearch?'iconfont icon-xiala rotate':'iconfont icon-xiala'"></i>
                    </div>

                    <transition name="zoom" enter-active-class="animated zoomIn"
                                leave-active-class="animated zoomOut"
                                :duration="300">
                        <div class="high-search-box" v-show="isSeniorSearch">
                            <div class="content-item">
                                <label class="between">间数</label>
                                <div class="item-body-box" >
                                    <div class="room-count" @click="close();isRoomCountShow = true">
                                        {{RoomCount}}
                                    </div>
                                    <transition name="bounce" enter-active-class="animated bounceInUp"
                                                leave-active-class="animated fadeOutDown"
                                                :duration="300">
                                        <RoomCount @select="selectCount" v-show="isRoomCountShow"></RoomCount>
                                    </transition>
                                </div>
                            </div>
                            <div class="content-item">
                                <label class="between">每间人数</label>
                                <div class="item-body">
                                    <div>
                                        <div class="select-box">
                                            <span @click="close();isRoomPeopelShow = true">{{AdultCount}}成人{{ChildrenCount}}儿童</span>
                                            <select></select>
                                        </div>
                                    </div>
                                </div>
                                <transition name="bounce" enter-active-class="animated bounceInUp"
                                            leave-active-class="animated fadeOutDown"
                                            :duration="300">
                                    <SelectHotelPeople @select="roomPeopelNum"
                                                       v-show="isRoomPeopelShow"></SelectHotelPeople>
                                </transition>
                            </div>
                            <div class="content-item">
                                <label class="between">酒店等级</label>
                                <div class="item-body-box" >
                                    <div class="room-count" @click="close();isHotelStarShow = true">
                                        <span class="room-count" v-if="Star === ''">不限</span>
                                        <span class="room-count" v-if="Star === '0,1'">二星及以下</span>
                                        <span class="room-count" v-if="Star === '2'">三星舒适</span>
                                        <span class="room-count" v-if="Star === '3'">四星高档</span>
                                        <span class="room-count" v-if="Star === '5'">五星豪华</span>
                                    </div>
                                    <transition name="bounce" enter-active-class="animated bounceInUp"
                                                leave-active-class="animated fadeOutDown"
                                                :duration="300">
                                        <HotelStar @select="selectStar" v-show="isHotelStarShow"></HotelStar>
                                    </transition>
                                </div>
                            </div>
                            <div class="content-item">
                                <label class="between">价格区间</label>
                                <div class="item-body-box" >
                                    <div class="room-count" @click="close();isHotelPriceShow = true">
                                        <span class="room-count" v-if="PriceCheck ===''">不限</span>
                                        <span class="room-count" v-if="PriceCheck =='0'">{{Currency}}150以下</span>
                                        <span class="room-count" v-if="PriceCheck =='1'">{{Currency}}150-300</span>
                                        <span class="room-count" v-if="PriceCheck =='2'">{{Currency}}300-600</span>
                                        <span class="room-count" v-if="PriceCheck =='3'">{{Currency}}600-1000</span>
                                        <span class="room-count" v-if="PriceCheck =='4'">{{Currency}}1000以上</span>
                                    </div>
                                    <transition name="bounce" enter-active-class="animated bounceInUp"
                                                leave-active-class="animated fadeOutDown"
                                                :duration="300">
                                        <HotelPrice @select="selectPrice" v-show="isHotelPriceShow" :Currency="Currency"></HotelPrice>
                                    </transition>
                                </div>
                            </div>
                            <div class="content-item">
                                <label class="between">客人国籍</label>
                                <div class="item-body-box" >
                                    <div class="room-count" @click="close();isCountryShow = true">
                                        {{Country.CNName}}
                                    </div>
                                    <transition name="bounce" enter-active-class="animated bounceInUp"
                                                leave-active-class="animated fadeOutDown"
                                                :duration="300">
                                        <Country @select="selectCountry" v-show="isCountryShow"></Country>
                                    </transition>
                                </div>
                            </div>

                        </div>
                    </transition>
                </div>
            </div>
            <!--</div>-->
        </div>
        <div class="links">
            <div class="link-item" @click="openLink('realTimeSelectionList')">
                <div class="bg">
                    <img src="../assets/img/linkBg/realTimeSelection.jpg" height="107" width="400"/>
                </div>
                <div class="text">
                    <h5>实时精选<img src="../assets/img/new.gif" class="link-item-new" /></h5>
                    <p>价格房态一目了然，快捷预订</p>
                </div>
            </div>
            <div class="link-item" @click="openLink('regimentRoom')">
                <div class="bg">
                    <img src="../assets/img/linkBg/regimentRoom.jpg" height="107" width="400"/>
                </div>
                <div class="text">
                    <h5>团房预订<img src="../assets/img/new.gif" class="link-item-new" /></h5>
                    <p>快速发布需求，获得最优报价方案</p>
                </div>
            </div>
            <div class="link-item">
                <div class="bg">
                    <img src="../assets/img/linkBg/recommendedHotels.jpg" height="107" width="400"/>
                </div>
                <div class="text">
                    <a href="/file/hotels.pdf" target="_blank">
                        <h5>主推酒店<img src="../assets/img/new.gif" class="link-item-new" /></h5>
                        <p>当月主推酒店列表下载</p>
                    </a>
                </div>
            </div>
        </div>
        <div class="home-history" v-if="history&&history.length>0">
            <h1><i class="iconfont icon-lishi-copy"></i>浏览历史</h1>
            <div class="home-history-box">
                <div class="home-history-box-item" v-for="(item,idx) in history" v-if="idx<4" @click="routeToDetails(item)">
                    <div class="image">
                        <ImgLoader :imgUrl="item.Pics[0].Url|replaceImgSrc(4)"  v-if="item.Pics.length>0"/>
                        <img src="./../assets/img/defaultHotel.jpg"  v-else >
                    </div>
                    <div class="text">
                        <h1>{{item.HotelName}}</h1>
                        <h2>{{item.date|dateClock}}</h2>
                    </div>
                </div>

            </div>
        </div>
        <div class="hot-product">
            <div class="rule">
                <div class="hot-title"><i class="iconfont icon-hot"></i>热销产品</div>
                <ul class="hot-nav" @mouseover="clearTime" @mouseout="HotSaleCityInterval">
                    <li v-for="(item,index) in HotSaleCityList"
                        :class="HotSaleCityIndex==index?'nav-item active':'nav-item'" @click="switchHotSaleCity(index)">
                        {{item.city}}
                    </li>
                </ul>
                <div class="hot-box" @mouseover="clearTime" @mouseout="HotSaleCityInterval">
                    <div class="page-btn last-btn" @click="HotSaleBtn('next')"><i class="iconfont icon-back"></i></div>
                    <div class="hot-list-box" v-show="!HotSaleCityHotelShow">
                        <div class="hot-list-in" :style="'left:-'+HotSaleCityIndex*1200+'px'">
                            <div class="hot-list-item" v-for="(i,inx) in HotSaleCityHoteList">
                                <ul :class="isTransition?'hot-list hot-list-transition':'hot-list'"
                                    :style="'left:-'+(HotSaleIndex*1200+HotSaleIndex*20)+'px'">
                                    <li class="list-item" v-for="(item,index) in i" @click="routeToDetails(item)">
                                        <div class="hot-img">
                                            <p>{{item.CommRate}}分 {{item.Evaluation}}</p>
                                            <img src="./../assets/img/defaultHotel.jpg"
                                                 v-if="!item.Pics||!item.Pics[0]">
                                            <ImgLoader :defaultImgUrl="'./../assets/img/defaultHotel.jpg'"
                                                       :imgUrl="item.Pics[0].Url|replaceImgSrc(9)" v-if="item.Pics[0]"/>
                                        </div>
                                        <div class="hot-content">
                                            <p class="hot-text">{{item.HotelName}}</p>
                                            <div class="hot-price" v-if="item.LowestPrice">
                                                {{Currency}}<span>{{item.LowestPrice}}</span>起
                                            </div>
                                            <div class="hot-price" v-if="!item.LowestPrice">
                                                特惠
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="page-btn next-btn" @click="HotSaleBtn('last')"><i class="iconfont icon-more"></i></div>
                    <div class="hot-list-loading" v-show="HotSaleCityHotelShow">
                        <Loading :isLoading="HotSaleCityHotelShow"></Loading>
                    </div>
                    <div class="more" @click="routerToHotHotel(HotSaleCityList[HotSaleCityIndex])">更多产品 <i
                            class="iconfont icon-more"></i></div>
                </div>
            </div>
        </div>
        <div class="hot-city">
            <div class="rule">
                <div class="hot-title"><i class="iconfont icon-pinzhibaozhang"></i>热门城市</div>
                <div class="hot-box">
                    <div class="hot-city-item1" @click="routerToHotHotel(hotHotelList[0])">
                        <img src="./../assets/img/img12.jpg" alt=""/>
                        <div class="tips">
                            <p class="address">香港</p>
                            <p class="count">{{hotHotelTotal[0]||'???'}}家酒店</p>
                        </div>
                    </div>
                    <div class="hot-city-item1">
                        <div class="hot-city-item2" @click="routerToHotHotel(hotHotelList[1])">
                            <img src="./../assets/img/img13.jpg" alt=""/>
                            <div class="tips">
                                <p class="address">澳门</p>
                                <p class="count">{{hotHotelTotal[1]||'???'}}家酒店</p>
                            </div>
                        </div>
                         <div class="hot-city-item2">
                            <div class="hot-city-item3" @click="routerToHotHotel(hotHotelList[4])">
                                <img src="./../assets/img/img16.jpg" alt=""/>
                                <div class="tips">
                                    <p class="address">广州</p>
                                    <p class="count">{{hotHotelTotal[4]||'???'}}家酒店</p>
                                </div>
                            </div>
                            <div class="hot-city-item3" @click="routerToHotHotel(hotHotelList[5])">
                                <img src="./../assets/img/img17.jpg" alt=""/>
                                <div class="tips">
                                    <p class="address">深圳</p>
                                    <p class="count">{{hotHotelTotal[5]||'???'}}家酒店</p>
                                </div>
                            </div>
                        </div>


                    </div>
                    <div class="hot-city-item1">
                         <div class="hot-city-item2">
                            <div class="hot-city-item3" @click="routerToHotHotel(hotHotelList[2])">
                                <img src="./../assets/img/img14.jpg" alt=""/>
                                <div class="tips">
                                    <p class="address">北京</p>
                                    <p class="count">{{hotHotelTotal[2]||'???'}}家酒店</p>
                                </div>
                            </div>
                            <div class="hot-city-item3" @click="routerToHotHotel(hotHotelList[3])">
                                <img src="./../assets/img/img15.jpg" alt=""/>
                                <div class="tips">
                                    <p class="address">上海</p>
                                    <p class="count">{{hotHotelTotal[3]||'???'}}家酒店</p>
                                </div>
                            </div>
                        </div>

                         <div class="hot-city-item2">
                            <div class="hot-city-item3" @click="routerToHotHotel(hotHotelList[7])">
                                <img src="./../assets/img/zhuhai.jpg" alt=""/>
                                <div class="tips">
                                    <p class="address">珠海</p>
                                    <p class="count">{{hotHotelTotal[7]||'???'}}家酒店</p>
                                </div>
                            </div>
                            <div class="hot-city-item3" @click="routerToHotHotel(hotHotelList[6])">
                                <img src="./../assets/img/mangu.jpg" alt=""/>
                                <div class="tips">
                                    <p class="address">曼谷</p>
                                    <p class="count">{{hotHotelTotal[6]||'???'}}家酒店</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="news">
            <div class="rule">
                <div class="news-title"><i class="iconfont icon-gonggao1"></i>新闻公告</div>
                <div class="notice">
                    <div class="news-logo"><i class="iconfont icon-gonggao"></i>系统公告</div>
                    <div class="news-content">
                        <p><a href="https://www.sohu.com/a/195143948_476087"><span class="new">NEW</span>[搜狐网] 龙腾捷旅要做酒店B2B领域的去哪儿 </a></p>
                        <p><a href="http://www.ctcnn.com/html/2014-08-22/19341709.html"><span class="new">NEW</span>[劲旅网] 龙腾捷旅冯木清：一个强大酒店分销平台对旅游同业的意义</a></p>
                        <p><a href="http://news.ifeng.com/a/20171030/52862166_0.shtml">[凤凰网] 龙腾捷旅荣获“2017最佳酒店B2B平台”奖项</a></p>
                        <p><a href="http://www.sohu.com/a/20548508_111395">[搜狐网] dayHR助力龙腾捷旅构筑“互联网+酒店预订”版图</a></p>
                        <p><a href="https://m.traveldaily.cn/article/85918">[环球旅讯] 龙腾捷旅：从6个方面努力维护客户最大价值</a></p>
                    </div>
                </div>
                <div class="media">
                    <div class="news-logo"><i class="iconfont icon-xinwen"></i>媒体报道</div>
                    <div class="news-content">
                        <p><a href="https://www.sohu.com/a/195143948_476087"><span class="new">NEW</span>[新旅界] 龙腾捷旅要做酒店B2B领域的去哪儿</a></p>
                        <p><a href="http://www.ctcnn.com/html/2014-08-22/19341709.html"><span class="new">NEW</span>[劲旅网] 龙腾捷旅冯木清：一个强大酒店分销平台对旅游同业的意义</a></p>
                        <p><a href="http://www.sohu.com/a/20548508_111395">[凤凰网] 龙腾捷旅荣获“2017最佳酒店B2B平台”奖项</a></p>
                        <p><a href="https://m.traveldaily.cn/article/85918">[搜狐网] dayHR助力龙腾捷旅构筑“互联网+酒店预订”版图</a></p>
                       	<p><a href="https://m.traveldaily.cn/article/85918">[环球旅讯] 龙腾捷旅：从6个方面努力维护客户最大价值</a></p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import DatePicker from './../common/cmpnt/datePicker/datePicker.vue'//日期
    import SearchAll from './../common/cmpnt/searchAll/SearchAll'//模糊搜索
    import HotCity from './../common/cmpnt/hotCity/HotCity.vue' //热门城市
    import RoomCount from './../common/cmpnt/roomCount/roomCount.vue' //选择房间数
    import HotelStar from './../common/cmpnt/hotelStar/hotelStar.vue' //选择房间数
    import HotelPrice from './../common/cmpnt/hotelPrice/hotelPrice.vue' //选择房间数
    import Country from './../common/cmpnt/country/country.vue' //选择房间数
    import SelectHotelPeople from './../common/cmpnt/selecthotelPeople/selecthotelPeople'//选择每间房间的住客数
    import ImgLoader from './../common/cmpnt/imgLoader/imgLoader.vue'//图片异步加载+效果
    import Loading from './../common/cmpnt/Loading/Loading.vue'//缓冲
    require('vue-swipe/dist/vue-swipe.css');
    const {Swipe, SwipeItem} = require('vue-swipe');

    export default {
        name: "Index",
        components: {
            DatePicker,
            SearchAll,
            HotCity,
            SelectHotelPeople,
            ImgLoader,
            Loading,
            RoomCount,
            HotelStar,
            HotelPrice,
            Country,
            SwipeItem,
            Swipe,
        },
        data() {
            return {
                PriceCheck: '',
                Currency: this.dao.get('userInfo')?this.dao.get('userInfo').Currency:"",
                list: [],
                HotSaleCityHoteList: [[],[],[],[],[],[],[],[],[]],
                isTransition: true,
                HotSaleCityHotelShow: false,
                HotSaleIndex: 0,
                HotSaleCityIndex: 0,
                HotSaleCityTime: null,
                BannerList: [],
                ProductType:'4',
                history: this.dao.get('hotelHistory')||[],
                HotSaleCity: '上海',
                HotSaleCityId: '0201',
                CheckIn: this.getDate(1),
                CheckOut: this.getDate(2),
                From: 1,
                RegionID: '',
                CityName: '',
                MyCityRegionID: '',
                Name: '',
                Landmark: '',
                LandmarkCode: '',
                LandmarkName: '',
                Star: '',
                PriceMin: '',
                PriceMax: '',
                RoomCount: 1,
                AdultCount: 2,
                ChildrenCount: 0,
                ChildrenAges: '',
                HotelIDs: '',
                Sort: '',
                MyLat: '',
                MyLon: '',
                key: '',
                isRoomCountShow:false,
                isHotelStarShow:false,
                isHotelPriceShow:false,
                isCountryShow:false,
                Country:{
                    "Code2": "CN",
                    "Code3": "CHN",
                    "Num": "156",
                    "Iso": "ISO 3166-2:CN",
                    "ENName": "China",
                    "CNName": "中国大陆"
                },
                keyResult: '',
                bannerList: '',
                HotSaleCityList: [
                    {city: '香港', RegionID: '3201', From: 1},
                    {city: '澳门', RegionID: '3301', From: 1},
                    {city: '北京', RegionID: '0101', From: 1},
                    {city: '上海', RegionID: '0201', From: 1},
                    {city: '广州', RegionID: '2001', From: 1},
                    {city: '深圳', RegionID: '2003', From: 1},
                    {city: '珠海', RegionID: '2004', From: 1},
                    {city: '曼谷', RegionID: 'EAN_604', From: 0},
                    {city: '普吉', RegionID: 'EAN_6046393', From: 0},
                ],
                hotHotelList: [
                    {city: '香港', RegionID: '3201', From: 1},
                    {city: '澳门', RegionID: '3301', From: 1},
                    {city: '北京', RegionID: '0101', From: 1},
                    {city: '上海', RegionID: '0201', From: 1},
                    {city: '广州', RegionID: '2001', From: 1},
                    {city: '深圳', RegionID: '2003', From: 1},
                    {city: '曼谷', RegionID: 'EAN_604', From: 0},
                    {city: '珠海', RegionID: '2004', From: 1},
                ],
                hotHotelTotal: [],
                isKeyResultShow: false,
                isHotCityShow: false,
                isRoomPeopelShow: false,
                isSeniorSearch: false,
                calendar: {
                    show: false,
                    start: this.getDate(0),
                    begin: this.getDate(1),
                    end: this.getDate(2),
                    select: (begin, end) => {
                        this.calendar.show = false;
                        if (!begin) {
                            return;
                        }
                        this.calendar.begin = begin;
                        this.calendar.end = end;
                        this.CheckIn = begin;
                        this.CheckOut = end;
                    }
                },
            }
        },
        watch: {
            key(val){
                this.$refs.keyRef.style.border="initial";
                if(!val){
                    this.RegionID='';
                }

            },
            PriceCheck(val) {
                switch (val) {
                    case '0':
                        this.PriceMin = 0;
                        this.PriceMax = 150;
                        break;
                    case '1':
                        this.PriceMin = 150;
                        this.PriceMax = 300;
                        break;
                    case '2':
                        this.PriceMin = 300;
                        this.PriceMax = 600;
                        break;
                    case '3':
                        this.PriceMin = 600;
                        this.PriceMax = 1000;
                        break;
                    case '4':
                        this.PriceMin = 1000;
                        this.PriceMax = '';
                        break;
                    default:
                        this.PriceMin = '';
                        this.PriceMax = '';
                }
            }
        },

        methods: {
            openLink(link){
                window.open('#/'+link, '_blank');
            },
            //滚动动画
            scrollAnimation(currentY, targetY) {
                let needScrollTop = targetY - currentY
                let _currentY = currentY
                setTimeout(() => {
                    const dist = Math.ceil(needScrollTop / 10)
                    _currentY += dist
                    window.scrollTo(_currentY, currentY)
                    if (needScrollTop > 10 || needScrollTop < -10) {
                        this.scrollAnimation(_currentY, targetY)
                    } else {
                        window.scrollTo(_currentY, targetY)
                    }
                }, 1)
            },
            searchBtn() {
                this.isKeyResultShow = false
                this.isHotCityShow = true
            },
            searchInput(){
                this.isKeyResultShow = true
                this.isHotCityShow = false
            },
            hotCity(obj) {
                this.isKeyResultShow = false;
                this.isHotCityShow = false;
                if (!obj) {
                    return
                }
                this.RegionID = obj.I;
                this.From = obj.F;
                this.CityName = obj.N;
                this.key = obj.N;

                this.Name = '';
                this.LandmarkName = '';
                this.LandmarkCode = '';
            },
            //
            searchScroll(e) {
                // document.documentElement.scrollTop = 450;
                // window.pageYOffset = 450;
                // document.body.scrollTop = 450;
                // document.getElementsByTagName('html')[0].scrollTop = 450
                var currentY = document.documentElement.scrollTop || document.body.scrollTop
                if (currentY < 450) {
                    this.scrollAnimation(currentY, 450)
                }
            },
            selectCount(val){
                this.close();
                if(!val) return;
                this.RoomCount = val;
            },
            selectStar(val){
                this.close();
                if(!val) return;
                if(val == '10'){
                    this.Star = '';
                }else{
                    this.Star = val;
                }
            },
            selectPrice(val){
                this.close();
                if(!val) return;
                if(val == '10'){
                    this.PriceCheck = '';
                }else{
                    this.PriceCheck = val;
                }
            },
            selectCountry(obj){
                this.close();
                if(!obj) return;
                this.Country = obj;
            },
            close(){
                this.isRoomCountShow = false;
                this.isHotelStarShow = false;
                this.isHotelPriceShow = false;
                this.isCountryShow = false;
            },
            //客人住房数
            roomPeopelNum(Adult, Children, ages) {
                this.isRoomPeopelShow = false;
                if (!Adult && !Children) {
                    return
                }
                if(Adult=='close'){
                    return;
                }
                this.AdultCount = Adult;
                this.ChildrenAges = ages;
                this.ChildrenCount = Children;
            },
            //选择城市
            selectCity(city) {
                this.RegionID = city.ID;
                this.From = city.From;
                this.CityName = city.CName;
                this.key = city.CName||city.SName;
                this.isKeyResultShow = false;

                this.Name = '';
                this.LandmarkName = '';
                this.LandmarkCode = '';
            },
            //选择酒店
            selectHotel(hotel) {
                this.isKeyResultShow = false;
                var obj={
                    ID:hotel.HotelID,
                    From:hotel.From,
                }
                //查询酒店信息
                this.routeToDetails(obj);
            },
            //选择地标
            selectLandmark(landmark) {
                this.RegionID = landmark.CityID;
                this.CityName = landmark.City;
                this.LandmarkCode = landmark.ID;
                this.LandmarkName = landmark.Name;
                this.From = landmark.From;
                this.key = landmark.Name;
                this.isKeyResultShow = false;

                this.Name = '';

            },
            //热销产品左右切换
            HotSaleBtn(type) {
                if (type == 'last') {
                    if (this.HotSaleIndex < 2) {
                        this.HotSaleIndex++
                    }
                } else {
                    if (this.HotSaleIndex > 0) {
                        this.HotSaleIndex--
                    }
                }
            },
            //获取热门城市的酒店数
            getHotHotelTotal() {
                //如何没有登录信息，则不发出请求
                if(!this.dao.get('userInfo'))return;

                var that = this;
                const hotHotelTotal = sessionStorage.getItem('hotHotelTotal')?JSON.parse(sessionStorage.getItem('hotHotelTotal')):'';
                if(hotHotelTotal){
                    that.hotHotelTotal = hotHotelTotal.hotHotelTotal
                }else{
                    for (let i = 0; i < that.hotHotelList.length; i++) {
                        var params = {
                            RegionID: that.hotHotelList[i].RegionID,
                            From: that.hotHotelList[i].From,
                            ProductType: 0,
                            Name: '',
                            Landmark: '',
                            Star: '',
                            PriceMin: '',
                            PriceMax: '',
                            CheckIn: that.CheckIn,
                            CheckOut: that.CheckOut,
                            RoomCount: 1,
                            AdultCount: 2,
                            ChildrenCount: 0,
                            ChildrenAges: [5, 5],
                            Page: 1,
                            PageSize: 0,
                            Sort: 0,
                        }
                        that.postRequest({
                            url: that.Api.price,
                            params: params
                        }).then(res => {
                            if (res && res.IsSuccess) {
                                that.hotHotelTotal[i] = res.Total;
                                var obj = {
                                    hotHotelTotal:that.hotHotelTotal
                                }
                                sessionStorage.setItem('hotHotelTotal', JSON.stringify(obj));
                                // that.dao.set('hotHotelTotal', obj,function () {return},that.twoDaysLater(new Date(),2));
                            }
                        });
                    }

                }
            },
            twoDaysLater(startDate,dateNum){
                startDate = new Date(startDate);
                startDate = +startDate + 1000 * 60 * 60 * 24 * dateNum;
                startDate = new Date(startDate);
                var m = (startDate.getMonth() + 1)<10?'0'+(startDate.getMonth() + 1):startDate.getMonth() + 1;
                var d = startDate.getDate()<10?'0'+startDate.getDate():startDate.getDate();
                var hour = startDate.getHours() < 10 ? "0" + startDate.getHours() : startDate.getHours();
                var minute = startDate.getMinutes() < 10 ? "0" + startDate.getMinutes() : startDate.getMinutes();
                var second = startDate.getSeconds() < 10 ? "0" + startDate.getSeconds() : startDate.getSeconds();
                var nextStartDate = startDate.getFullYear() + "-" + m + "-" + d+' '+ hour + ":" + minute + ":" + second;
                return nextStartDate;
            },
            clearTime() {
                window.clearInterval(this.HotSaleCityTime)
            },
            //热销产品，城市选择
            switchHotSaleCity(i) {
                var that = this;
                this.HotSaleCityIndex = i;
                if (that.HotSaleIndex !== 0) {
                    that.isTransition = false;
                    that.HotSaleIndex = 0;
                    setTimeout(function () {
                        that.isTransition = true;
                    }, 10)
                }
                if(that.HotSaleCityHoteList[that.HotSaleCityIndex].length==0){
                    clearInterval(that.HotSaleCityTime)
                    that.getHotSaleCityHotel(that.HotSaleCityIndex)
                }
                clearInterval(that.HotSaleCityTime)
            },
            //获取广告图片
            getBannerList(){
                var that=this;
                that.getRequest({
                    url: that.Api.banner
                }).then(res => {
                    if(res&&res.IsSuccess){
                        that.bannerList=res.Result;
                    }
                });
            },
            //热销产品，城市自动滚动
            HotSaleCityInterval() {
                var that = this;
                that.HotSaleCityTime = window.setInterval(function () {
                    if (that.HotSaleIndex != 0) {
                        that.isTransition = false;
                        that.HotSaleIndex = 0;
                        setTimeout(function () {
                            that.isTransition = true;
                        }, 10)
                    }
                    that.HotSaleCityIndex++;
                    if(that.HotSaleCityIndex<9&&that.HotSaleCityHoteList[that.HotSaleCityIndex].length==0){
                        clearInterval(that.HotSaleCityTime)
                        that.getHotSaleCityHotel(that.HotSaleCityIndex)
                    }
                    if (that.HotSaleCityIndex == 9) {
                        that.HotSaleCityIndex = 0;
                    }
                }, 3000)
            },
            //获取热销城市酒店列表
            getHotSaleCityHotel(i) {
                var that = this;
                //如何没有登录信息，则不发出请求
                if(!this.dao.get('userInfo'))return;
                that.HotSaleIndex = 0;
                const HotSaleCityHoteList = sessionStorage.getItem('HotSaleCityHoteList')?JSON.parse(sessionStorage.getItem('HotSaleCityHoteList')):'';
                if(HotSaleCityHoteList){
                    that.HotSaleCityHoteList = HotSaleCityHoteList.HotSaleCityHoteList
                }else{
                    for (let i = 0; i < that.HotSaleCityList.length; i++) {
                        that.HotSaleCityHotelShow = true;
                        var params = {
                            RegionID: that.HotSaleCityList[i].RegionID,
                            From: that.HotSaleCityList[i].From,
                            ProductType: 0,
                            Name: '',
                            Landmark: '',
                            Star: '',
                            PriceMin: '',
                            PriceMax: '',
                            CheckIn: that.CheckIn,
                            CheckOut: that.CheckOut,
                            RoomCount: 1,
                            AdultCount: 2,
                            ChildrenCount: 0,
                            ChildrenAges: [5, 5],
                            Page: 1,
                            PageSize: 12,
                            HotelIDs: '',
                            Sort: 0,
                            MyLat: '',
                            MyLon: '',
                            Radius: '',
                            MyCityRegionID: '',
                        }
                        that.postRequest({
                            url: that.Api.price,
                            params: params
                        }).then(res => {
                            if (res && res.IsSuccess) {
                                that.HotSaleCityHotelShow = false;
                                that.HotSaleCityHoteList[i] = res.Result;
                                var obj = {
                                    HotSaleCityHoteList:that.HotSaleCityHoteList
                                }
                                sessionStorage.setItem('HotSaleCityHoteList', JSON.stringify(obj));
                                // that.dao.set('HotSaleCityHoteList', obj,function () {return},that.twoDaysLater(new Date(),1));
                                that.$nextTick(() => {
                                    if(localStorage.getItem('lang')=='t'){
                                        that.$zh_tran(localStorage.getItem('lang'))
                                    }
                                })
                            }
                        });
                    }

                }

                that.HotSaleCityInterval()
            },
            //获取热门城市的酒店列表
            getHotHotels() {
                var that = this;
                //如何没有登录信息，则不发出请求
                if(!this.dao.get('userInfo'))return;

                var params = {
                    RegionID: '',
                    From: this.From,
                    ProductType: 0,
                    Name: '',
                    Landmark: '',
                    Star: '',
                    PriceMin: '',
                    PriceMax: '',
                    CheckIn: that.CheckIn,
                    CheckOut: that.CheckOut,
                    RoomCount: 1,
                    AdultCount: 2,
                    ChildrenCount: 0,
                    ChildrenAges: [5, 5],
                    Page: 1,
                    PageSize: 10,
                    HotelIDs: '',
                    Sort: 0,
                    MyLat: '',
                    MyLon: '',
                    Radius: '',
                    MyCityRegionID: '',
                }
                that.postRequest({
                    url: that.Api.price,
                    params: params
                }).then(res => {
                    if (res && res.IsSuccess && res.Result.length > 0) {
                        that.list = res.Result;
                        that.$nextTick(() => {
                            if(localStorage.getItem('lang')=='t'){
                                that.$zh_tran(localStorage.getItem('lang'))
                            }
                        })
                    }
                });
            },
            //字符串关键字高亮
            highLight(string, key) {
                if (!string) return;
                var array = [];
                var str = '';
                array = string.split('');
                for (var i = 0; i < array.length; i++) {
                    if (key.indexOf(array[i]) > -1) {
                        str += '<span class="key-words">' + array[i] + '</span>';
                    } else {
                        str += array[i];
                    }
                }
                return str;
            },
            //模糊查询
            getHotelAndLandmarks() {
                var that = this;
                var params = {
                    q: that.key,
                    page: 1,
                    pageSize: 5,
                }
                that.getRequest({
                    url: that.Api.getHotelAndLandmarks,
                    params: params
                }).then(res => {
                    if (res && res.IsSuccess) {
                        that.keyResult = res.Result;
                        that.$nextTick(() => {
                            if(localStorage.getItem('lang')=='t'){
                                that.$zh_tran(localStorage.getItem('lang'))
                            }    
                        })
                    }
                });
                
            },

            routeToHotel() {
                //若没有选择城市或者地标，则显示提示框提醒
                if(!this.key||!this.RegionID){
                    const el = this.$refs.keyRef;
                    el.style.border="2px solid #28c667";
                    el.classList.add("blink-border");
                    this.$refs.keyInput.focus();
                    el.addEventListener('animationend', () => el.classList.remove('blink-border'), {once:true});
                    // this.error({title: '提示', content: '请输入酒店名称/城市/景点/关键字！'});
                    return;
                }

                var obj = {
                    RegionID: this.RegionID,
                    CityName: this.CityName,
                    MyCityRegionID: this.MyCityRegionID,
                    districtId: this.districtId,
                    From: this.From,
                    Name: this.Name,
                    Landmark: this.Landmark,
                    LandmarkCode: this.LandmarkCode,
                    LandmarkName: this.LandmarkName,
                    Star: this.Star,
                    Country:this.Country,
                    PriceMin: this.PriceMin,
                    PriceMax: this.PriceMax,
                    CheckIn: this.CheckIn,
                    CheckOut: this.CheckOut,
                    RoomCount: this.RoomCount,
                    AdultCount: this.AdultCount,
                    ChildrenCount: this.ChildrenCount,
                    ChildrenAges: this.ChildrenAges,
                    HotelIDs: this.HotelID,
                    Sort: this.Sort,
                    MyLat: this.MyLat,
                    MyLon: this.MyLon,
                    MyPositionLat: this.MyPositionLat,
                    MyPositionLon: this.MyPositionLon,
                    key: this.key,
                }
                this.dao.set('hotelListSearchParams', obj);
                this.$router.push('/hotelList');
            },
            routerToHotHotel(item) {
                var obj = {
                    RegionID: item.RegionID,
                    CityName: item.city,
                    MyCityRegionID: '',
                    districtId: '',
                    From: item.From,
                    Name: '',
                    Landmark: '',
                    LandmarkCode: '',
                    LandmarkName: '',
                    Star: '',
                    PriceMin: '',
                    PriceMax: '',
                    CheckIn: this.getDate(1),
                    CheckOut: this.getDate(2),
                    RoomCount: 1,
                    AdultCount: 2,
                    ChildrenCount: 0,
                    ChildrenAges: [],
                    HotelIDs: '',
                    Sort: '',
                    MyLat: '',
                    MyLon: '',
                    MyPositionLat: this.MyPositionLat,
                    MyPositionLon: this.MyPositionLon,
                    key: item.city,
                    Country:this.Country,
                }
                this.dao.set('hotelListSearchParams', obj);
                this.$router.push('/hotelList');
            },
            //从广告图进去产品详情
            bannerToHotel(img){
                if(!img.ProductID)return;//广告图不能点详情页
                var Id=img.ProductID;
                var From=img.ProductID>=5000000?0:1;

                var obj={
                    HotelID:Id,
                    ProductType:'4',
                    From:From,
                    CheckIn: this.CheckIn,
                    CheckOut: this.CheckOut,
                    ProductType:'4',
                    RoomCount: 1,
                    AdultCount: 2,
                    ChildrenCount: 0,
                    ChildrenAges: [],
                    MyLat: this.MyLat,
                    MyLon: this.MyLon,
                    Country:this.Country,
                    MyCityRegionID: this.MyCityRegionID,
                }
                this.dao.set('hotelDetailsParams', obj)
                this.$router.push('/hotelDetails')

            },

            //打开详情
            routeToDetails(item) {

                var obj = {
                    HotelID: item.ID,
                    From: item.From,
                    CheckIn: this.CheckIn,
                    CheckOut: this.CheckOut,
                    ProductType:'4',
                    RoomCount: 1,
                    AdultCount: 2,
                    ChildrenCount: 0,
                    ChildrenAges: [],
                    MyLat: this.MyLat,
                    MyLon: this.MyLon,
                    RegionID: item.RegionID,
                    Country:this.Country,
                    MyCityRegionID: this.MyCityRegionID,
                }
                this.dao.set('hotelDetailsParams', obj)
                this.$router.push('/hotelDetails')

            },
            bannerBtn(type) {
                if (type == 'next') {
                    this.$refs.swiper.next()
                } else {
                    this.$refs.swiper.prev();
                }
            },
            getBanner() {
                var that = this;
                that.getRequest({
                    url: that.Api.banner,
                    params: ''
                }).then(res => {
                    if (res && res.IsSuccess) {
                        that.BannerList = res.Result;
                    }
                });
            }

        },
        mounted() {
            //获取热门城市的酒店列表
            this.getHotHotelTotal();
            this.getHotHotels();
            this.getHotSaleCityHotel(0);
            this.getBannerList();
            document.title='以酒店预订为核心的自游行产品交易平台,订房易,香港酒店,澳门酒店,国内酒店,海外酒店,门票预订,自由行预订';
            var that = this
            that.$nextTick(() => {
                if(localStorage.getItem('lang')=='t'){
                    that.$zh_tran(localStorage.getItem('lang'))
                }
            })
        },
        activated(){
            this.getHotHotelTotal();
            document.title='以酒店预订为核心的自游行产品交易平台,订房易,香港酒店,澳门酒店,国内酒店,海外酒店,门票预订,自由行预订';

            //如何没有登录信息，则不发出请求
            if(!this.dao.get('userInfo'))return;
        }
    }
</script>
























// WEBPACK FOOTER //
// src/components/Index.vue